import Result from 'slotworks/model/gameplay/records/results/result';

export default class WildStickyRecorder extends Result {
    gameName: string;
    persistedProgress: { WILD_SPIN_DATA: any };
    stickedWildsList: number[];
}

export interface SymbolWildData {
    awarded: number;
    position: number;
    remain: number;
}



// WEBPACK FOOTER //
// ./src/integration/wild-sticky-record.ts